import { GraphApiMethod, GraphApiResponse } from '@/api/core';
import { HandleErrorInput, handleError } from '@/utils/custom';
import createGraphApiHook, { CreateGraphApiHookHook } from '@/hooks/createGraphApiHook';

import { DeleteProviderLocationMappingBulkDocument } from '@/api/queries';
import { DeleteProviderLocationMappingInput } from '@/models/gen/graphql';
import graphApi from '@/api';

// Global Service Variables
const onError = (res: HandleErrorInput): void => handleError(res, { notification: { title: 'Delete Client Mapping' } });

// Service Function Signature
type ServiceMethodPayload = string[];
interface ServiceMethod {
  (payload: ServiceMethodPayload): Promise<GraphApiResponse>;
}

// DeleteProviderLocationMappingBulk Service
export const { deleteProviderLocationMappingBulk, useDeleteProviderLocationMappingBulk } = ((): {
  deleteProviderLocationMappingBulk: ServiceMethod;
  useDeleteProviderLocationMappingBulk: CreateGraphApiHookHook<ServiceMethod>;
} => {
  const [mutate] = graphApi(DeleteProviderLocationMappingBulkDocument, {
    onError,
  }).map(
    (fn: GraphApiMethod<typeof DeleteProviderLocationMappingBulkDocument>): ServiceMethod =>
      async (ids: ServiceMethodPayload): Promise<GraphApiResponse> => {
        const search: DeleteProviderLocationMappingInput[] = ids.map((id: string): DeleteProviderLocationMappingInput => ({ id }));
        const res = await fn({ input: { search } });
        return res;
      }
  );

  const useService = createGraphApiHook(mutate, { bubble: true });
  return {
    deleteProviderLocationMappingBulk: mutate,
    useDeleteProviderLocationMappingBulk: useService,
  };
})();
